/** Minimal shape for checklist section header counts (blocking = API required missing). */
export interface ChecklistSummaryItem {
  present: boolean;
  checked: boolean;
  /** True when completeness flagged this slug as a blocking missing document. */
  blocking?: boolean;
  notApplicable?: boolean | string | { reason: string } | null;
}

export interface ChecklistSectionCounts {
  present: number;
  blockingMissing: number;
  optionalOpen: number;
  na: number;
}

export function summarizeChecklistItems(items: ChecklistSummaryItem[]): ChecklistSectionCounts {
  const active = items.filter((i) => i.checked);
  return {
    present: active.filter((i) => i.present).length,
    blockingMissing: active.filter((i) => i.blocking && !i.present && !i.notApplicable).length,
    optionalOpen: active.filter((i) => !i.blocking && !i.present && !i.notApplicable).length,
    na: active.filter((i) => i.notApplicable).length,
  };
}
